import React from "react";

import { NameCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function name({ width, onResize }: Column.Options) {
	return base(ColumnId.Name, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default name;
